export default "__VITE_ASSET__ixrduaq4__"